<template>
  <v-dialog persistent v-model="dialog" max-width="700">
    <v-form ref="activityForm" v-model="validActivity" :lazy-validation="lazy">
      <v-card :loading="loading">
        <v-card-title class="headline">{{ (isNew) ? 'Attività senza nome' : activity.description }}</v-card-title>
        <v-card-subtitle>{{ (isNew) ? 'Crea una nuova Attività' : `Modifica l'attività ${activity.description}` }}</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Area</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-select v-model="activity.areaId" :items="areas" item-value="id" item-text="description" placeholder="Area di pertinenza" single-line filled dense required readonly></v-select>
            </v-col>
          </v-row>
          <v-row style="margin-top: -25px;">
            <v-col xl="2" lg="2" md="2" sm="2" class="hidden-xs-only">
              <v-subheader>Descrizione</v-subheader>
            </v-col>
            <v-col xl="10" lg="10" md="10" sm="10" xs="12">
              <v-text-field v-model="activity.description" placeholder="Descrizione attività" :rules="descriptionRules" :counter=100 single-line filled dense required clearable></v-text-field>
            </v-col>
          </v-row>
            <v-row v-if="error.hasErrors">
              <v-col class="col-12" v-for="(e, i) in error.errors" :key="i">
                <v-alert dense outlined type="error"><strong>ATTENZIONE!</strong> {{ e }}</v-alert>
              </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small dark color="red" @click="clear()">Annulla</v-btn>
          <v-btn small dark color="green" :disabled="!(validActivity)" :loading="loading" @click="save()">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import apiRepository from '../../api/api-repository';

export default {
  name: 'ActivityForm',
  props: [ 'isNew', 'activity', 'areas' ],

  data: ()=> ({
    lazy: true, // tipo di validazione del form.
    dialog: false, // flag della dialog.
    loading: false, // flag di caricamento.
    validActivity: true, // flag di validità del form.
    error: { hasErrors: false, errors: new Array() }, // stato degli errori.

    descriptionRules: [
      (v)=> !!v || 'Descrizione attività obbligatoria',
      (v)=> (v != undefined) ? (v.length < 100) || 'La descrizione non può essere maggiore di 100 caratteri' : '',
      (v)=> (v != undefined) ? (v.length > 3) || 'La descrizione non può essere inferiore a 3 caratteri' : ''
    ]
  }),

  methods: {
    open(){
      this.validActivity = true; // setto il flag di validità del form.
      this.error = { hasErrors: false, errors: new Array() }; // resetto il box degli errori.
      // se esiste la referenza del form lo resetto.
      if(this.$refs.activityForm) this.$refs.activityForm.resetValidation(); // resetto la validazione del form.
      // apro il form di creazione.
      this.dialog = true; // apro la dialog.
    },

    clear(){
      this.dialog = false; // chiudo la dialog.
      this.$refs.activityForm.resetValidation(); // resetto la validazione del form.
    },

    async save(){
      // se il form non è valido esco dal salvataggio.
      if(!this.$refs.activityForm.validate()) return;
      // form valido, proseguo con il salvataggio.
      this.loading = true; // setto il form in caricamento.

      try{
        // preparo la request per la creazione dell'attività.
        let req = { 
          id: (this.activity.id) ? this.activity.id : null,
          areaId: this.activity.areaId, 
          description: this.activity.description 
        };
        // chiamo la api di creazione di una nuova attività.
        let res = (this.isNew) ? await apiRepository.activities().create(req) : await apiRepository.activities().update(req); // attendo il risultato della chiamata.
        // aggiorno lo stato della dialog.
        this.loading = false; // disabilito il caricamento.
        // this.dialog = false; // chiudo la dialog.
        this.clear();
        // emetto l'evento di salvataggio riuscito.
        this.$emit('saved', res); // restituisco il risultato agli ascoltatori.
      }
      catch(e){
        this.loading = false; // disabilito il caricamento.
        this.error.hasErrors = true; // abilito il box degli errori.
        this.error.errors = e.errors; // aggiorno la lista degli errori.
      }
    }
  }
}
</script>